import { StripeCardNumberElementOptions } from "@stripe/stripe-js";

export const CARD_ELEMENT_OPTIONS: StripeCardNumberElementOptions = {
  // showIcon: false,
  // iconStyle: "solid",
  style: {
    base: {
      "color": "#6d6d6d",
      "::placeholder": {
        color: "rgba(109, 109, 109,0.5)"
      }
    },
    invalid: {
      "color": "#6d6d6d",
      "::placeholder": {
        color: "rgba(109, 109, 109,0.5)"
      }
    }
  }
};
export const FEATURE_NAME = "Swyft.PaymentDeposit";
